import axios from 'axios';
import config from '../config';

export type Product = {
  name: string;
  description: string;
  price: number;
  allowBankSlip: boolean;
  thankYouPage: string;
  boletoPage: string;
  imageUrl: string;
  defaultInstallments?: number;
};

axios.defaults.baseURL = config.endpointBaseUrl;

export const getProductDetails = async (productId: string) => {
  const { data: product } = await axios.get<Product>(`/product/${productId}`);
  return product;
};
